import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

interface ContasReceber {
  parceiro: string;
  cpf: string
  vencimento: Date;
  fazenda: string;
  cultivo: string;
  historico: string;
  numerodoc: string;
  valorcompra: number; 
  recebido: number;
  acrescimos: number;
  desconto: number;
  valorparcela: number;
  receber: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const RelatorioContasReceber = async (parceiro: string, fazenda: string, cultivo: string, datainicial: string, datafinal: string): Promise<ContasReceber[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontasreceber?fazenda=${fazenda}&parceiro=${parceiro}&cultivo=${cultivo}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
  

export const RelatorioContasReceberService = {
  RelatorioContasReceber
};